export default __webpack_public_path__ + "static/media/Left Hand of Nergal.6102878f.jpg";